import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center w-full h-auto gap-10 p-4" }

import { IonPage, IonContent } from '@ionic/vue';
import TagComponent from '../../components/DetailPage/CheckpointPage/TagComponent.vue'
import CheckpointComponent from '@/components/DetailPage/CheckpointPage/CheckpointComponent.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckpointsPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TagComponent),
            _createVNode(CheckpointComponent)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})